import { render, staticRenderFns } from "./AuthSplitLayout.vue?vue&type=template&id=489af81c"
import script from "./AuthSplitLayout.vue?vue&type=script&lang=js"
export * from "./AuthSplitLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthSplitLayout.vue?vue&type=style&index=0&id=489af81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports